module.exports = __webpack_public_path__ + "media/images/favicons/favicon-c099b35e520affd54867913f6363ebae.ico";